const MuiLink = {
    defaultProps: {
        underline: 'none' as const,
    },
};

export { MuiLink };
